<template>
    <div class="orderBaseInfo">
        <slot name="order_info_title"></slot>
        <div class="orderBaseInfoTable">
            <slot name="orderBaseInfoTable"></slot>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
};
</script>

<style>
.orderBaseInfoTable .el-table__header th{
    border: 0;
    background: #f1f1f1;
}
.el-table::before {
    background: #fff;
}
.orderBaseInfoTable .orderCover{
    width: 178px;
    height: 116px;

}
.orderBaseInfoTable .orderCover img{
    width: 100%;
    height: 100%;
}
</style>

<style lang="less" scoped>
.colorOrange{
    font-weight: bold;
    color: #ffaa15;
}

.orderBaseInfoTable {
    margin-top: 24px;
}
.order_info_title {
    padding: 0 2px;
    height: 26px;
    border-bottom: solid 1px #dadada;
    font-family: "微软雅黑";
    display: flex;
    flex-direction: row;
    align-items: center;
    > p {
        font-size: 16px;
        font-weight: bold;
        color: #000;
    }
    > span {
        margin: 0 4px;
        font-size: 12px;
        color: #818181;
    }
}
.orderBaseInfo {
    padding: 42px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #ecedf1;
}
</style>
